// extracted by mini-css-extract-plugin
export var canvas = "_d-1";
export var container = "_d-0";
export var fallback = "_d-2";